<template>
  <header class="logged">
    <HeaderLogo />

    <div class="header_right">
      <HeaderNavigation :user-authenticated="isUserAuthenticated" />

      <HeaderLanguage />

      <HeaderMenuIcon />
    </div>
  </header>

  <TheMenu :user-authenticated="isUserAuthenticated" />
</template>

<script setup>
import HeaderLogo from '@/components/header/HeaderLogo.vue';
import HeaderNavigation from '@/components/header/HeaderNavigation.vue';
import HeaderLanguage from '@/components/header/HeaderLanguage.vue';
import HeaderMenuIcon from '@/components/header/HeaderMenuIcon.vue';
import TheMenu from '@/components/menu/TheMenu.vue';
import useAuthStore from '@/store/modules/auth.js';

const isUserAuthenticated = useAuthStore().isUserAuthenticated;
</script>
